import React from 'react'

export const RecommendationsIcon = React.forwardRef<SVGSVGElement>((props, ref): React.ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>
      <path d="M10.5 20L13.5 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M9 16L15 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M9 12L15 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M18.8176 16C19.5602 14.8089 19.9677 13.4446 19.9982 12.0473C20.0286 10.6499 19.6811 9.26968 18.9911 8.04825C18.3011 6.82683 17.2935 5.80816 16.0718 5.09677C14.8501 4.38538 13.4581 4.00687 12.0388 4.00009C10.6195 3.99331 9.2239 4.3585 7.99521 5.05819C6.76652 5.75788 5.74898 6.76687 5.047 7.98165C4.34501 9.19643 3.98384 10.5732 4.00055 11.9709C4.01727 13.3685 4.41126 14.7365 5.14211 15.9347"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default RecommendationsIcon
